import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableExporterModule } from 'mat-table-exporter';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { BreadcrumbsModule } from 'src/@vex/components/breadcrumbs/breadcrumbs.module';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { AppMaterialModule } from 'src/app/app.material.module';
import { DesaparecidoGamFormComponent } from './desaparecidos/desaparecido-gam-form/desaparecido-gam-form.component';
import { DesaparecidoGamListComponent } from './desaparecidos/desaparecido-gam-list/desaparecido-gam-list.component';
import { DesaparecidoImageFormComponent } from './desaparecidos/desaparecido-image-form/desaparecido-image-form.component';
import { GamRoutingModule } from './gam-routing.module';
import { PublicadoViewComponent } from './desaparecidos/publicacion-view/publicado-view.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';


@NgModule({
  declarations: [
    DesaparecidoGamListComponent,
    DesaparecidoGamFormComponent,
    DesaparecidoImageFormComponent,
    PublicadoViewComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    GamRoutingModule,
    AppMaterialModule,
    PageLayoutModule,
    BreadcrumbsModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableExporterModule,
    MatRadioModule,
    MaterialFileInputModule
  ]
})
export class GamModule { }
